/*globals noUiSlider */
(function () {
  var esPriceSlider, updateSliderValue;

  // The Connected Slider Control
  esPriceSlider = document.getElementById('esPriceSlider');

  if(esPriceSlider) {
    updateSliderValue = function (slider) {
      var children, value;
      children = slider.getElementsByClassName('noUi-handle');
      value = slider.noUiSlider.get();

      children[0].dataset.value = (parseInt(value) + "€").replace(".", ",");

      if(escApp && escApp.price.value !== parseInt(value)) {
        escApp.price.value = parseInt(value);
      }

      return value;
    };

    noUiSlider.create(esPriceSlider, {
      animationDuration: 300,
      start: 30,
      step: 1,
      range: {
        'min': 10,
        'max': 100 
      } 
    });

    esPriceSlider.noUiSlider.on('update', function () {
      return updateSliderValue(esPriceSlider);
    });
  }

}).call(this);